/**
 * Copy text for a "Copy" button. navigator.clipboard is missing on http pages and
 * rejects when the browser blocks clipboard access (an unhandled rejection before);
 * then the older select-and-copy path is tried, and if that fails too the person is
 * told to copy it by hand - never a false "copied".
 *
 *   copyText(url, 'Link copied')      -> Promise<boolean>
 */
import { toast } from 'sonner';

function legacyCopy(text) {
  try {
    const el = document.createElement('textarea');
    el.value = text;
    el.setAttribute('readonly', '');
    el.style.position = 'fixed';
    el.style.opacity = '0';
    document.body.appendChild(el);
    el.select();
    const ok = document.execCommand && document.execCommand('copy');
    document.body.removeChild(el);
    return !!ok;
  } catch (_) {
    return false;
  }
}

export async function copyText(text, successMessage = 'Copied') {
  const value = String(text ?? '');
  let ok = false;
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(value);
      ok = true;
    }
  } catch (_) {
    ok = false;
  }
  if (!ok) ok = legacyCopy(value);
  if (ok) {
    if (successMessage) toast.success(successMessage);
  } else {
    toast.error('This browser blocked copying. Select the text and copy it by hand.');
  }
  return ok;
}

export default copyText;
